import { createFileRoute, redirect } from '@tanstack/react-router';

import { sessionQueries } from '@/api';
import { VehiclePage } from '@/features/vehicles/vehicle-page';

export const Route = createFileRoute('/vehicles/$vehicleId')({
	beforeLoad: async ({ context, params }) => {
		const session = await context.queryClient.ensureQueryData(sessionQueries.current());
		if (!session) throw redirect({ to: '/login', search: { redirect: `/vehicles/${params.vehicleId}` } });
	},
	component: VehiclePage,
	staticData: { workspace: true },
});
